import React, { Fragment } from 'react';
import Modal from 'library/components/modal';
import CreditCardModal from 'apps/billing/components/credit-card-modal';

const BRAND_LENGTHS = {
  'American Express': 15
};

const CARD_ICONS = {
  'American Express': 'amex',
  'Diners Club': 'diners',
  'Discover': 'discover',
  'JCB': 'jcb',
  'MasterCard': 'mastercard',
  'Visa': 'visa'
};

const FormatCardNumber = (last4, brand='Visa') => {
  let CN = (new Array(BRAND_LENGTHS[brand]||16)).fill('*').join('');

  if (brand === 'American Express') {
    CN = CN.slice(0,4) + ' ' + CN.slice(4,10) + ' ' + CN.slice(10);
  } else {
    CN = CN.slice(0,4) + ' ' + CN.slice(4,8) + ' ' + CN.slice(8,12) + ' ' + CN.slice(12);
  }

  return CN.replace(/\*{4}$/, last4);
};

class CreditCard extends React.Component {
  state = {
    active: false
  }

  toggle = () => {
    this.setState({
      active: !this.state.active
    });
  }

  render() {
    const {
      address_city,
      address_state,
      address_line1,
      address_line2,
      address_zip,
      brand,
      last4,
      cardholder_name,
      default_payment_method,
      exp_month,
      exp_year,
      index
    } = this.props;

    const values = {
      full_name: cardholder_name,
      address_1: address_line1,
      address_2: address_line2,
      city: address_city,
      state: address_state,
      zip_code: address_zip,
      default_payment_method,
      index,
    };

    return  (
      <Fragment>
        <div key={index} onClick={this.toggle} className="billing-credit-card">
          {
            default_payment_method
              ? <div className="billing-credit-card-default">DEFAULT</div>
              : null
          }
          <label className="credit-card-number">
            <div className="stripe-credit-card-number">{FormatCardNumber(last4, brand)}</div>
            <span>card number</span>
          </label>
          <label className="credit-card-expiration">
            <div className="stripe-credit-card-expiration" name="expiration">{`${exp_month} / ${exp_year}`}</div>
            <span>expiration</span>
          </label>
          <img className="billing-credit-card-icon" src={`/billing/cards/${CARD_ICONS[brand]||'other'}.png`} />
          <span className="credit-card-name">{cardholder_name}</span>
        </div>
        <Modal onClose={this.toggle} active={this.state.active}>
          <CreditCardModal
            edit
            onClose={this.toggle}
            values={values}
            {...this.props}
          />
        </Modal>
      </Fragment>
    );
  }
}

export default CreditCard;
